// extracted by css-extract-rspack-plugin
export default {"cls1":"TrendAdornment-cls1_p_T","cls2":"TrendAdornment-cls2_BJ7 TrendAdornment-cls1_p_T"};